export default __webpack_public_path__ + "static/values-win-together-d3def46129cdad155b368457191a1b06.svg";